import axios from 'axios';
import React, { useEffect, useState, useCallback } from 'react';
import {
  clearSession,
  refreshSession,
  validateSession,
} from '../utils/sessionAuth';
import Login from './login';

const apiUrl = process.env.REACT_APP_API_URL || 'https://api.mosuseoul.com';

const Adm = () => {
  const [, setLunchData] = useState({
    type: 'Lunch',
    name: '',
    price: '',
    description: '',
  });

  const [, setDinnerData] = useState({
    type: 'Dinner',
    name: '',
    price: '',
    description: '',
  });

  const [, setWinelistData] = useState({
    type: 'Winelist',
    name: '',
    price: '',
    description: '',
  });

  const [lunchMenu, setLunchMenu] = useState('');
  const [dinnerMenu, setDinnerMenu] = useState('');
  const [winelistMenu, setWinelistMenu] = useState('');

  const [files, setFiles] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // 사용자 활동 감지 및 세션 갱신
  const handleUserActivity = useCallback(() => {
    refreshSession();
  }, []);

  const logOut = () => {
    clearSession();
    setIsAuthenticated(false);
    document.location.href = '/adm';
  };

  const handleFileChange = (e) => {
    handleUserActivity(); // 사용자 활동 감지
    setFiles([]);
    const allowedExtensions = ['pdf'];

    if (e.target.files.length > 0) {
      const { name: fileName } = e.target.files[0];

      const fileExtension = fileName.split('.').pop();

      if (!allowedExtensions.includes(fileExtension)) {
        alert('메뉴 파일은 Pdf 확장자만 가능합니다.');
        e.target.value = '';
        setFiles([]);
      } else {
        setFiles(Array.from(e.target.files));
      }
    }
  };

  const uploadFile = (e, type) => {
    e.preventDefault();
    handleUserActivity(); // 사용자 활동 감지
    const formData = new FormData();

    if (files.length > 0) {
      formData.append('type', type);
      formData.append('file', files[0]);

      axios
        .post(`${apiUrl}/api/menu/file/type`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            alert('정상적으로 등록 되었습니다.');
            if (type === 'Dinner') {
              getMenuTypeDinner();
            } else if (type === 'Lunch') {
              getMenuTypeLunch();
            } else {
              getMenuTypeWinelist();
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const getMenuTypeLunch = useCallback(async () => {
    try {
      const result = await axios.post(
        `${apiUrl}/api/menu/type`,
        { type: 'Lunch' },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (result.status === 200) {
        setLunchData({
          type: 'Lunch',
          name: result.data?.name,
          price: result.data?.price,
          description: result.data?.description,
        });

        if (result.data.files.length > 0) {
          setLunchMenu(result.data.files[0].storedFileName);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, []);

  const getMenuTypeDinner = useCallback(async () => {
    try {
      const result = await axios.post(
        `${apiUrl}/api/menu/type`,
        { type: 'Dinner' },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (result.status === 200) {
        console.log(result.data);

        setDinnerData({
          type: 'Dinner',
          name: result.data?.name,
          price: result.data?.price,
          description: result.data?.description,
        });

        if (result.data.files.length > 0) {
          setDinnerMenu(result.data.files[0].storedFileName);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, []);

  const getMenuTypeWinelist = useCallback(async () => {
    try {
      const result = await axios.post(
        `${apiUrl}/api/menu/type`,
        { type: 'Winelist' },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (result.status === 200) {
        console.log(result.data);

        setWinelistData({
          type: 'Winelist',
          name: result.data?.name,
          price: result.data?.price,
          description: result.data?.description,
        });

        if (result.data.files.length > 0) {
          setWinelistMenu(result.data.files[0].storedFileName);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    document.body.classList.add('admin-page');

    const isValidSession = validateSession();

    if (isValidSession) {
      getMenuTypeLunch();
      getMenuTypeDinner();
      getMenuTypeWinelist();
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }

    const sessionCheckInterval = setInterval(() => {
      if (!validateSession()) {
        setIsAuthenticated(false);
        clearSession();
        alert('세션이 만료되었습니다. 다시 로그인해주세요.');
      }
    }, 300000);

    // 사용자 활동 감지 이벤트 리스너 추가
    const activityEvents = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
    ];

    for (const event of activityEvents) {
      document.addEventListener(event, handleUserActivity, true);
    }

    // 컴포넌트 언마운트 시 정리
    return () => {
      clearInterval(sessionCheckInterval);
      for (const event of activityEvents) {
        document.removeEventListener(event, handleUserActivity, true);
      }
    };
  }, [
    getMenuTypeLunch,
    getMenuTypeDinner,
    getMenuTypeWinelist,
    handleUserActivity,
  ]);

  return (
    <>
      {!isAuthenticated && <Login />}
      {isAuthenticated && (
        <section className={'admin-page'}>
          <header>
            <h4>MOSU Admin Page</h4>
            <button
              type="button"
              className={'btn-logout'}
              onClick={() => logOut()}
            >
              Log out
            </button>
          </header>

          <div className={'admin-content-box'}>
            <h4>Menu Files Upload</h4>

            <ul>
              {String(lunchMenu).length > 0 && (
                <li>
                  File download :{' '}
                  <a
                    href="https://cdn.data.mosuseoul.com/Lunch.pdf"
                    rel="noreferrer"
                    target={'_blank'}
                  >
                    {lunchMenu}
                  </a>
                </li>
              )}
              {String(dinnerMenu).length > 0 && (
                <li>
                  File download :{' '}
                  <a
                    href="https://cdn.data.mosuseoul.com/Dinner.pdf"
                    rel="noreferrer"
                    target={'_blank'}
                  >
                    {dinnerMenu}
                  </a>
                </li>
              )}
              {String(winelistMenu).length > 0 && (
                <li>
                  File download :{' '}
                  <a
                    href="https://cdn.data.mosuseoul.com/Winelist.pdf"
                    rel="noreferrer"
                    target={'_blank'}
                  >
                    {winelistMenu}
                  </a>
                </li>
              )}
            </ul>

            <div className="item">
              <form>
                <b>Lunch</b>
                <input
                  className="file-input"
                  type="file"
                  onChange={(e) => handleFileChange(e)}
                />
                <button
                  type="button"
                  className={'btn-upload'}
                  onClick={(e) => uploadFile(e, 'Lunch')}
                >
                  upload
                </button>
              </form>
            </div>

            <div className="item">
              <form>
                <b>Dinner</b>
                <input
                  className="file-input"
                  type="file"
                  onChange={(e) => handleFileChange(e)}
                />
                <button
                  type="button"
                  className={'btn-upload'}
                  onClick={(e) => uploadFile(e, 'Dinner')}
                >
                  upload
                </button>
              </form>
            </div>

            <div className="item">
              <form>
                <b>Winelist</b>
                <input
                  className="file-input"
                  type="file"
                  onChange={(e) => handleFileChange(e)}
                />
                <button
                  type="button"
                  className={'btn-upload'}
                  onClick={(e) => uploadFile(e, 'Winelist')}
                >
                  upload
                </button>
              </form>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Adm;
